export enum StoreType {
    NONE = '',
    DIST = 'D',
    PAYMENT = 'P',
}
